// extracted by mini-css-extract-plugin
export default {"formContent":"gfCDGCxNdF"};